module.exports = __webpack_public_path__ + "static/img/JCHOME@2x.92eff16f.png";